import { render, staticRenderFns } from "./EmployeesSubsidiesNumber.vue?vue&type=template&id=194cc470&scoped=true&"
import script from "./EmployeesSubsidiesNumber.vue?vue&type=script&lang=js&"
export * from "./EmployeesSubsidiesNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194cc470",
  null
  
)

export default component.exports